import React from "react";
import { Form } from "antd";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import LegalViewTypeForm from "./LegalViewTypeForm";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import TickBox from "../../../core/ui/components/grid/TickBox";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
interface LegalViewTypeGridProps {
  translate: any;
  legalViewTypes: IDocumentType[];
  createLegalViewType: any;
  referenceLoader?: boolean;
  updateLegalViewType;
}
const LegalViewTypeGrid: React.FC<LegalViewTypeGridProps> = ({
  translate,
  legalViewTypes,
  createLegalViewType,
  referenceLoader,
  updateLegalViewType
}) => {
  const builder = DataGridConfigurationBuilder({
    translate,
    resourcePrefix: "editors.legal_view_types.fields"
  });
  const columns = builder.buildColumns("code", "name", "description", {
    name: "valid",
    dataKey: "valid",
    sortable: false,
    align: "center",
    render: (record) => <TickBox value={record.valid} />
  });

  const [CreateForm] = Form.useForm();
  const [UpdateForm] = Form.useForm();

  return (
    <DataGrid
      title={translate("editors.legal_view_types.title")}
      columns={columns}
      translate={translate}
      dataSource={legalViewTypes || []}
      allowCreate={true}
      allowUpdate={true}
      addButtonText={translate("editors.legal_view_types.add_new_text")}
      createForm={<LegalViewTypeForm translate={translate} form={CreateForm} />}
      updateForm={<LegalViewTypeForm translate={translate} form={UpdateForm} />}
      createModalTitle={`${translate(
        "editors.legal_view_types.create_modal_title"
      )}`}
      updateModalTitle={`${translate(
        "editors.legal_view_types.update_modal_title"
      )}`}
      loading={referenceLoader}
      onCreate={(e) => {
        createLegalViewType(e);
      }}
      onUpdate={updateLegalViewType}
      booleanColumnKeys={["valid"]}
      createModalClass={"modal-width"}
      updateModalClass={"modal-width"}
      keyProperty={"code"}
      CreateFormInstance={CreateForm}
      UpdateFormInstance={UpdateForm}
      createActionPosition={"topRight"}
    />
  );
};
export default LegalViewTypeGrid;
